import {BaseModel} from '../models/base/base.model';

import {ErrorApi} from '../models/errorApi.model';
import { Input, OnChanges, SimpleChanges, Output, EventEmitter, Directive, ChangeDetectorRef, inject } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {IServiceBase} from '../services/base/IServiceBase';
import {MessageDialog} from '../../components/message-dialog/messageDialog';
import { observable, Observable } from 'rxjs';
import { Location } from '@angular/common';
import { Configuration } from '../configuration/configuration';

@Directive()
export abstract class EditFormBase<
  T extends BaseModel,
  Y extends string | number
> implements OnChanges {
  private ref: ChangeDetectorRef;

  constructor(
    protected _modelService: IServiceBase<T>,
    protected _messageDialog: MessageDialog,
    protected _route: ActivatedRoute,
    protected _router: Router,
    protected _location: Location,
    private tType: new () => T,
    patch: boolean = false
  ) {
    this.patch = patch;
    this.ref = inject(ChangeDetectorRef);
  }

  @Input() model: T;
  @Input() id: Y;
  @Input() isNew: boolean;
  @Output() onCreate: EventEmitter<any> = new EventEmitter();
  @Output() onUpdate: EventEmitter<{model: T, success: boolean}> = new EventEmitter();
  @Output() onModelLoad: EventEmitter<any> = new EventEmitter();



  parentId?: any;
  loading = false;
  disableOnChanges = false;
  anyChanges = false;
  private patch: boolean;

  onSubmit(form) {

    let validForm: boolean;

    if (Object.prototype.hasOwnProperty.call(form, form)) {
      // Template driven
      validForm = form.form.valid;
    } else {
      // Reactive Form
      validForm = form.valid;
    }

    if (validForm) {
      if (this.model.isNew) {
        this.create();
      } else {
        this.update();
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.ref.detectChanges();
    if (this.disableOnChanges) { return; }
    if (changes) {
      for (const propName in changes) {
        if (changes.hasOwnProperty(propName) && propName === 'id') {
          const chng = changes[propName];
          if (chng.currentValue !== chng.previousValue) {
            this.id = chng.currentValue;
            this.getModel();
          }
        }
      }
    }
  }

  /**
   * @description
   * Obtiene el identificador del modelo desde la ruta.
   **/
  getIdFromRoute() {
    //console.log( this._route.params);
    this._route.params.subscribe(params => {
      this.id = params['id'] as Y;
    });
  }

  /**
   * @description
   * Obtiene el modelo mediante una llamada al service, usando el identificador obtenido desde la ruta.
   **/
  getModel() {
    if (!this.id) {
      this.getIdFromRoute();
    }

    if (this.id && this.id !== Configuration.newPath) {
      //console.log(this.id);
      this._modelService.getModel(this.id, this.parentId).subscribe(
        res => {
          this.model = Object.assign(this.getModelInstance(), res);
          this.onModelLoad.emit();
          this.afterModelLoad();
        },
        err => console.error(err)
      );
    } else {
      this.model = this.getModelInstance();
      this.onModelLoad.emit();
      this.afterModelLoad();
    }

    if (this.model) {
      this.isNew = this.model.isNew;
    } else {
      this.isNew = false;
    }
  }

  /**
   * @description
   * Método que realiza la llamada al service para crear el modelo en base de datos.
   * */
  create() {
    this.loading = true;
    this._modelService.add(this.model, this.parentId).subscribe(
      res => {
        this.anyChanges = true;
        this.model = res as T;
        this.id = (this.model.Id) as Y;
        // console.log(this.id);
        this.afterModelCreated(true);
        this.onCreate.emit(this.id);
        this._messageDialog.ShowMessage(
          'Elemento creado correctamente',
          'Creado'
        );
        this.redirect();
        this.loading = false;
        this.isNew = this.model.isNew;
      },
      err => {
        this.loading = false;
        this._messageDialog.ShowException(err);
        this.afterModelCreated(false);
      }
    );
  }

  /**
   * @description
   * Método que realiza la llamada al service para actualizar el modelo en base de datos.
   * */
  update(mensaje: string = 'Elemento actualizado correctamente') {
    this.loading = true;

    let obs: Observable<T>;

    obs = this._modelService.update(this.id, this.model, this.parentId);

    obs.subscribe(
      res => {
        this._messageDialog.ShowMessage(mensaje, 'Actualizado');

        if(res) {
          this.model = res as T;
        }
        this.onUpdate.emit({model: this.model, success: true});
        this.loading = false;
        this.anyChanges = true;
        this.afterModelUpdated(true);

      },
      err => {
        console.error(err);
        if (ErrorApi.instanceOfErrorApi(err)) {
          this._messageDialog.ShowException(err);
        }
        this.loading = false;
        this.onUpdate.emit({model: this.model, success: false});
        this.afterModelUpdated(false);
      }
    );
  }

  redirect() {
    this._router.navigate([this.id], {state: window.history.state, relativeTo:this._route.parent});
  }

  /**
   * @description
   * Método que se ejecuta después de cargar el modelo obtenido desde el service.
   * */
  abstract afterModelLoad(): void;


  /**
   * @description
   * Método que se ejecuta después de actualizar el modelo.
   * */
  abstract afterModelUpdated(success: boolean): void;


  /**
   * @description
   * Método que se ejecuta después de actualizar el modelo.
   * */
  abstract afterModelCreated(success: boolean): void;


  /**
   * @description
   */
  abstract getModelInstance(): T;
}


